import './mocks.css';

/* A browser window with an address bar. Children render in the viewport. */
export default function BrowserFrame({ url = 'yourlab.com', children, dark = false, className }) {
  const classes = ['mock-browser'];
  if (dark) classes.push('mock-browser--dark');
  if (className) classes.push(className);
  return (
    <div className={classes.join(' ')}>
      <div className="mock-browser__bar" aria-hidden="true">
        <span className="mock-browser__dots">
          <span />
          <span />
          <span />
        </span>
        <span className="mock-browser__url">{url}</span>
      </div>
      <div className="mock-browser__viewport">{children}</div>
    </div>
  );
}
